// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__4nrAX","left":"StickyBox_left__1ONRj","right":"StickyBox_right__2VfJB"};